import { Component, OnInit } from '@angular/core';
import { LocalStorage } from '../../shared/wrappers/LocalStorage';
import { RULES } from '../../shared/auth/Roles';
import { UserProvider } from '../../shared/providers/user.provider';
import { Router } from '@angular/router';


@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss'],
})
export class HomeComponent implements OnInit {
  constructor(
    private localStorage: LocalStorage,
    public userProvider: UserProvider,
    private router: Router
  ) {}

  user;
  listCardsHome: Array<any>;
  rules

  ngOnInit() {
    this.checkPermissions();
  }

  checkPermissions() {
    this.user = this.localStorage.retrieve('user');
    this.buildHome(this.user.permission);
  }

  buildHome(permission) {
    this.rules = RULES[permission];

    if (this.rules.commonResources.length > 0) {
      this.listCardsHome = this.rules.commonResources.map((resource) =>  this.transcriptRule(resource))
    }
  }

  transcriptRule(commomModule) {
    let Module = {
      ['dashboard']: {
        path: "/dashboard",
        name: 'Dashboard',
        iconClass: 'icon-dashboard'
      },
      ['billing-letter']: {
        path: "/billing-letter",
        name: 'Carta de Faturamento',
        iconClass: 'icon-wallet'
      },
      ['approvals']: {
        path: "/approvals",
        name: 'Aprovação',
        iconClass: 'icon-check'
      },
      ['refunds']: {
        path: "/refunds",
        name: 'Reembolsos',
        iconClass: 'icon-wallet'
      },
      ['purchase-orders']: {
        path: "/purchase-orders",
        name: 'Pedido de Compra',
        iconClass: 'icon-credit-card'
      },
      ['companies']: {
        path: "/companies",
        name: 'Empresa',
        iconClass: 'icon-briefcase'
      },
      ['projects']: {
        path: "/projects",
        name: 'Projeto',
        iconClass: 'icon-check'
      },
    //   ['project-cost']: {
    //     path: "/project-cost",
    //     name: 'Projeção de Custo',
    //     iconClass: 'icon-wallet'
    //   },
    //   ['products']: {
    //     path: "/products",
    //     name: 'Produtos',
    //     iconClass: 'icon-bag'
    //   },
      ['cnaes']: {
        path: "/cnaes",
        name: 'CNAES e Itens',
        iconClass: 'icon-list'
      },
      ['consultants']: {
        path: "/consultants",
        name: 'Consultores',
        iconClass: 'icon-people'
      },
      ['reports']: {
        path: `/reports${this.user.permission == "controllership"? "/consultant": null}`,
        name: 'Relatórios',
        iconClass: 'icon-chart'
      },
    //   ['legal-certificates']: {
    //     path: "/legal-certificates",
    //     name: 'Alerta de Documentos',
    //     iconClass: 'icon-docs'
    //   },
      ['users']: {
        path: "/users",
        name: "Usuários",
        iconClass: 'icon-user'
      },
      ['accounting-block']: {
        path: "/accounting-block",
        name: "Período Contábil",
        iconClass: "fa fa-lock"
      }
    }

    return Module[commomModule]
  }
}



// WEBPACK FOOTER //
// ./src/app/views/home/home.component.ts